<template>
  <div class="table-controls-item filter-datepicker d-flex align-items-center">
    <button
      class="date-period-btn-left"
      :disabled="disablePrev"
      @click.prevent="$emit('changePeriod', 'prev')"
    >
      &lt;
    </button>
    <div class="d-flex align-items-center filter-dateweek" :class="singleMode ? 'date-picker-wrap' : ''">
      <Datepicker
        class="cursor-pointer"
        :bootstrap-styling="true"
        :monday-first="mondayFirst"
        :value="startDate"
        :disabled="disabledDatepickers"
        :disabled-dates="disabledStartDates"
        :format="dateFormat"
        :minimum-view="minimumView"
        :position="datepickerPosition"
        @selected="(v) => $emit('selectDate', v, singleMode ? 'single' : 'start')"
      />
      <span v-if="showSeparator && showEndDate">-</span>
      <Datepicker
        v-if="showEndDate"
        class="cursor-pointer"
        :bootstrap-styling="true"
        :monday-first="mondayFirst"
        :value="endDate"
        :disabled="disabledDatepickers"
        :disabled-dates="disabledEndDates"
        :format="dateFormat"
        :minimum-view="minimumView"
        @selected="(v) => $emit('selectDate', v, 'end')"
      />
    </div>
    <button
      class="date-period-btn-right"
      :disabled="disableNext"
      @click.prevent="$emit('changePeriod', 'next')"
    >
      &gt;
    </button>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
  name: 'DatePeriodNavigation',
  components: {
    Datepicker
  },
  props: {
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      default: null
    },
    showSeparator: {
      type: Boolean,
      default: true
    },
    disablePrev: {
      type: Boolean,
      default: false
    },
    disableNext: {
      type: Boolean,
      default: false
    },
    disabledDatepickers: {
      type: Boolean,
      default: false
    },
    disabledStartDates: {
      type: Object,
      default: () => ({})
    },
    disabledEndDates: {
      type: Object,
      default: () => ({})
    },
    dateFormat: {
      type: String,
      default: 'dd/MM/yy'
    },
    mondayFirst: {
      type: Boolean,
      default: true
    },
    singleMode: {
      type: Boolean,
      default: false
    },
    minimumView: {
      type: String,
      default: 'day'
    },
    datepickerPosition: {
      type: String,
      default: 'bottom'
    }
  },
  computed: {
    showEndDate () {
      return !this.singleMode
    }
  },
  emits: ['changePeriod', 'selectDate']
}
</script>

<style lang="scss" scoped>
.date-period-btn {
  display: flex;
  padding: 7px 10px;
  align-items: center;
  border: 1px solid #F3F5F7;
  background: #FFF;
  transition: all 0.15s ease-in-out;
  color: #7489A9;
  text-align: center;
  font-family: Ubuntu;
  font-size: 13px;
  font-weight: 400;
  line-height: 15.6px;

  &:hover:not(:disabled) {
    background: #F3F5F7;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.date-period-btn-right {
  @extend .date-period-btn;
  border-radius: 0 5px 5px 0;
}

.date-period-btn-left {
  @extend .date-period-btn;
  border-radius: 5px 0 0 5px;
}

.filter-dateweek {
  max-height: 30px;
  font-size: 13px;
  line-height: 22px;
  text-align: center;
  gap: 8px;
  background-color: white;
  margin: 0 2px;

  ::v-deep .form-control {
    cursor: pointer !important;
    padding: 0 !important;
    font-weight: 400;
  }
}

.date-picker-wrap {
  ::v-deep input.form-control {
    padding: unset !important;
  }

  ::v-deep .vdp-datepicker .vdp-datepicker__calendar {
    right: 0px;
  }
}

::v-deep .vdp-datepicker {
  width: 55px;
}
</style>
